// src/components/layout/Header.tsx
import { Link } from 'react-router-dom';
import { Calculator } from 'lucide-react';

const Header = () => {
  return (
    <header className="sticky top-0 z-50 w-full border-b bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60">
      <div className="container mx-auto px-4 py-4">
        <nav className="max-w-5xl mx-auto flex items-center justify-between">
          <Link 
            to="/" 
            className="flex items-center space-x-3 hover:opacity-90 transition-opacity"
          >
            <Calculator className="h-8 w-8 md:h-10 md:w-10 text-blue-600" />
            <div>
              <span className="text-2xl md:text-3xl font-bold">
                PayPal Gebührenrechner
              </span>
              <p className="text-sm text-gray-600 hidden md:block">
                Aktuelle Gebühren seit Januar 2025
              </p>
            </div>
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;